import { render, staticRenderFns } from "./scroll-bar.vue?vue&type=template&id=02c944ff&scoped=true&"
import script from "./scroll-bar.vue?vue&type=script&lang=js&"
export * from "./scroll-bar.vue?vue&type=script&lang=js&"
import style0 from "./scroll-bar.vue?vue&type=style&index=0&id=02c944ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c944ff",
  null
  
)

export default component.exports